import DiaSemanaEnum from '../Enum/DiaSemanaEnum';

class DemandaEmbarque {
  constructor() {
    this.UTEIS = 1;
    this.UTEIS_SAB = 2;
    this.UTEIS_DOM = 3;
    this.TODOS = 4;
  }

  static getDiasTodos() {
    return [
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.DOMINGO },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEGUNDA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.TERCA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUARTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUINTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEXTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SABADO },
    ];
  }

  static getDiasUteis() {
    return [
      { ocorreEmbarque: false, diaSemana: DiaSemanaEnum.DOMINGO },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEGUNDA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.TERCA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUARTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUINTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEXTA },
      { ocorreEmbarque: false, diaSemana: DiaSemanaEnum.SABADO },
    ];
  }

  static getDiasUteisSabado() {
    return [
      { ocorreEmbarque: false, diaSemana: DiaSemanaEnum.DOMINGO },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEGUNDA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.TERCA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUARTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUINTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEXTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SABADO },
    ];
  }

  static getDiasUteisDomingo() {
    return [
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.DOMINGO },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEGUNDA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.TERCA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUARTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.QUINTA },
      { ocorreEmbarque: true, diaSemana: DiaSemanaEnum.SEXTA },
      { ocorreEmbarque: false, diaSemana: DiaSemanaEnum.SABADO },
    ];
  }

  getOptions() {
    return [
      {
        value: this.UTEIS,
        name: 'Segunda a sexta',
        embarque: DemandaEmbarque.getDiasUteis(),
      },
      {
        value: this.TODOS,
        name: 'Todos os dias',
        embarque: DemandaEmbarque.getDiasTodos(),
      },
      {
        value: this.UTEIS_SAB,
        name: 'Dias úteis e sábados',
        embarque: DemandaEmbarque.getDiasUteisSabado(),
      },
      {
        value: this.UTEIS_DOM,
        name: 'Dias úteis e domingos',
        embarque: DemandaEmbarque.getDiasUteisDomingo(),
      },
    ];
  }

  getOption(value) {
    return this.getOptions()
      .filter(option => option.value === value)
      .shift();
  }

  getEmbarqueOption(diasOcorreEmbarque) {
    if (!diasOcorreEmbarque || !diasOcorreEmbarque.length) {
      return this.getOption(this.UTEIS);
    }

    const optionResult = this.getOptions().find(
      option =>
        JSON.stringify(option.embarque) === JSON.stringify(diasOcorreEmbarque)
    );

    return optionResult || this.getOption(this.UTEIS);
  }
}

export default new DemandaEmbarque();
